<app-admin-student-platform-dashboard></app-admin-student-platform-dashboard>